"use client";

import { AlertCircle, Bot } from "lucide-react";
import { ReactNode } from "react";
import TypingMarkdown from './Markdown/Markdown';

const AlertMessage = ({ message }: { message: string }) => {
  return (
    <div className="mb-5 mt-5 flex animate-fadeIn relative w-full">
      <div className="flex items-center gap-4 p-4 rounded-3xl w-full n-chat-msj shadow bg-yellow-50 text-yellow-800 text-sm text-gray-700">
        <AlertCircle className="w-6 h-6 text-yellow-800" />
        <div>
            <TypingMarkdown>{message}</TypingMarkdown>
        </div>
      </div>
      <div className={`absolute bg-white  -bottom-10  border-b-[2px]
                    -left-5 border-l-[2px] 
                  transform -translate-y-1/2 
                  rounded-full  
                  border-slate-300
                  flex items-center 
                  justify-center`}> 
                    
                    <Bot strokeWidth={1.8} size={30} className="m-1"/>  
                  </div>
    </div>
  );
};

export default AlertMessage;
